import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../../rest-api.service';
import { BaseInventoryComponent } from '../base-inventory/base-inventory.component';


@Component({
  selector: 'app-print-inventory',
  templateUrl: './print-inventory.component.html',
  styleUrls: ['./print-inventory.component.css']
})
export class PrintInventoryComponent extends BaseInventoryComponent implements OnInit {

  constructor(public restApi: RestApiService) {
    super(restApi);
    this.getInventoryEndpoint = restApi.getAvailablePrints;
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
